import { ContractLegalTextPdfResponse } from 'api/contractAuthAPI'

export function handleLegalTextData(data: ContractLegalTextPdfResponse) {
  switch (data?.contract_source) {
    case 'IND2IND': {
      return {
        type: 'content',
        resultAr: data.data.legalTextAr,
        resultEn: data.data.legalTextEn,
        tag: data.contract_source,
      }
    }
    case 'EST2IND': {
      return {
        type: 'content',
        resultAr: data?.data?.legal_text,
        resultEn: data?.data?.legal_text,
        tag: data.contract_source,
      }
    }
    case 'CONTRACT_AUTHENTICATION': {
      return {
        type: 'content',
        resultAr: data.data.label_ar,
        resultEn: data.data.label_en,
        tag: data.contract_source,
      }
    }
    case 'ETAWTHEEQ': {
      return {
        type: 'content',
        resultAr: data?.data,
        resultEn: data?.data,
        tag: data.contract_source,
      }
    }
    default:
      return undefined
  }
}
